import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from '@app/components/shared/base-modal/base-modal.component';
import { ModalControlsComponent } from '@app/components/shared/modal-controls/modal-controls.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-change-payment-modal',
  standalone: true,
  imports: [BaseModalComponent, ModalControlsComponent, TranslatePipe],
  templateUrl: './change-payment-modal.component.html',
  styleUrl: './change-payment-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePaymentModalComponent {
  protected readonly payload = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ChangePaymentModalComponent>);

  protected close(): void {
    this.dialogRef.close();
  }

  public proceed(): void {
    this.dialogRef.close(this.payload.newActive);
  }
}
